import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaWallet, FaGift, FaHome, FaHeadset, FaUserCog } from "react-icons/fa";

import "../css/BottonMenu.css";

const menuItems = [
  { to: "/wallet", label: "Wallet", key: "wallet", Icon: FaWallet },
  { to: "/refer", label: "Refer", key: "refer", Icon: FaGift },
  { to: "/landing", label: "Home", key: "home", Icon: FaHome },
  { to: "/support", label: "Support", key: "support", Icon: FaHeadset },
  { to: "/Profile", label: "Profile", key: "profile", Icon: FaUserCog },
];

const getActiveIndex = (pathname) => {
  const index = menuItems.findIndex(({ to, key }) => {
    if (key === "home") {
      return (
        pathname === "/" ||
        pathname === "/landing" ||
        pathname.startsWith("/landing/")
      );
    }

    return pathname === to || pathname.startsWith(`${to}/`);
  });

  return index >= 0 ? index : 2;
};

const BottonMenu = ({ w3_close }) => {
  const location = useLocation();
  const [clickedKey, setClickedKey] = useState("");
  const clickTimer = useRef(null);
  const selectedIndex = getActiveIndex(location.pathname);

  useEffect(() => {
    return () => {
      if (clickTimer.current) clearTimeout(clickTimer.current);
    };
  }, []);

  const handleMenuClick = (key) => {
    if (clickTimer.current) clearTimeout(clickTimer.current);

    setClickedKey(key);
    clickTimer.current = setTimeout(() => {
      setClickedKey("");
      clickTimer.current = null;
    }, 480);

    if (typeof w3_close === "function") w3_close();
  };

  return (
    <div className="blx-footer-wrapper">
      <nav
        className="blx-footer"
        aria-label="Bottom navigation"
        style={{ "--active-index": selectedIndex }}
      >
        {/* Gradient frame + moving SVG tab */}
        <span className="blx-footer-frame" aria-hidden="true" />

        <span className="blx-footer-slider" aria-hidden="true">
          <svg
            className="blx-footer-active-shape"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient id="blxGoldFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fff46b" />
                <stop offset="45%" stopColor="#ffdc24" />
                <stop offset="100%" stopColor="#ffb900" />
              </linearGradient>
              <linearGradient id="blxGoldStroke" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#fff7a0" />
                <stop offset="50%" stopColor="#ffc928" />
                <stop offset="100%" stopColor="#ffef76" />
              </linearGradient>
            </defs>
            <path
              className="blx-footer-active-path"
              d="M 1,0 H 99 L 84,72 Q 81,89 65,99 Q 50,103 35,99 Q 19,89 16,72 Z"
              fill="url(#blxGoldFill)"
              stroke="url(#blxGoldStroke)"
              strokeWidth="1.8"
              vectorEffect="non-scaling-stroke"
            />
            <path
              d="M 8,2 H 92 Q 95,2 93,5 L 87,9 H 13 L 7,5 Q 5,2 8,2 Z"
              fill="rgba(255,255,255,0.58)"
            />
            <path
              d="M 34,91 Q 50,95 66,91"
              fill="none"
              stroke="rgba(255,255,255,0.68)"
              strokeWidth="1.1"
              vectorEffect="non-scaling-stroke"
            />
          </svg>
          <span className="blx-footer-tab-glow" />
        </span>

        {menuItems.map(({ to, label, key, Icon }, index) => (
          <NavLink
            key={key}
            to={to}
            end={key === "home"}
            className={({ isActive }) => {
              const routeActive =
                key === "home"
                  ? location.pathname === "/" ||
                    location.pathname === "/landing" ||
                    location.pathname.startsWith("/landing/")
                  : isActive;

              return [
                "blx-footer-item",
                `blx-footer-${key}`,
                index === selectedIndex || routeActive
                  ? "blx-footer-active"
                  : "",
                clickedKey === key ? "blx-footer-clicked" : "",
              ]
                .filter(Boolean)
                .join(" ");
            }}
            aria-label={label}
            aria-current={index === selectedIndex ? "page" : undefined}
            onClick={() => handleMenuClick(key)}
          >
            <span className="blx-footer-icon-motion">
              <Icon className="blx-footer-icon" aria-hidden="true" />
            </span>
            <span className="blx-footer-label">{label}</span>
            <span className="blx-footer-ripple" aria-hidden="true" />
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default BottonMenu;
